export default __webpack_public_path__ + "a37626b230bbc0c89125932bcd2dae6c.svg";